<template>
  <div class="layout">
    <Layout>
      <div class="left-box" data-html2canvas-ignore>
        <div class="logo">
          <div
            class="box"
            :style="{ marginRight: leftSwitch ? '8px' : '0px' }"
          ></div>
          <div v-if="leftSwitch" class="text">
            <!-- <p class="text-title">宏兔兔课后托管</p> -->
            <p
              v-if="userInfo.orgName"
              class="text-title"
              :title="userInfo.orgName"
            >
              {{ userInfo.orgName }}
            </p>
            <p v-else class="text-title" :title="userInfo.orgName">
              {{ portOrg | InitportOrgType() }}
            </p>
          </div>
        </div>
        <div v-if="leftSwitch" class="left-nav-cell">
          <Sider
            ref="side1"
            v-model="isCollapsed"
            class="left-nav"
            hide-trigger
            :collapsible="false"
            :collapsed-width="100"
            width="180px"
          >
            <Menu
              ref="menu"
              :active-name="leftNavActive"
              theme="dark"
              width="180px"
              :open-names="leftNavOpen"
              :class="menuitemClasses"
              @on-select="onMenuSelect"
            >
              <div v-for="item in leftNavList" :key="item.menuId">
                <!-- 只有一级目录 -->
                <MenuItem
                  v-if="item.childList.length === 0"
                  :name="item.menuUrl"
                  :to="{ name: item.menuUrl }"
                >
                  <span>{{ item.menuName }}</span>
                </MenuItem>
                <!-- 只有二级目录 -->
                <Submenu
                  v-if="item.childList.length !== 0"
                  :name="item.menuUrl"
                >
                  <template slot="title">
                    {{ item.menuName }}
                  </template>
                  <div v-for="subItem in item.childList" :key="subItem.menuId">
                    <MenuItem
                      v-if="subItem.childList.length === 0"
                      :name="subItem.menuUrl"
                      :to="{ name: subItem.menuUrl }"
                    >
                      <i class="dot"></i>
                      {{ subItem.menuName }}
                    </MenuItem>
                    <Submenu
                      v-if="subItem.childList.length !== 0"
                      :name="subItem.menuUrl"
                    >
                      <template slot="title">
                        <i class="dot"></i>
                        {{ subItem.menuName }}
                      </template>
                      <MenuItem
                        v-for="subItemChild in subItem.childList"
                        :key="subItemChild.menuId"
                        :name="subItemChild.menuUrl"
                        :to="{ name: subItemChild.menuUrl }"
                      >
                        <span class="text-span">{{
                          subItemChild.menuName
                        }}</span>
                      </MenuItem>
                    </Submenu>
                  </div>
                </Submenu>
              </div>
            </Menu>
          </Sider>
        </div>
        <div
          class="left-nav-switch"
          :class="{ leftNavClose: !leftSwitch }"
          @click="handleLeftSwitch"
        >
          <img :src="leftSwitch ? leftSwitchOpen : leftSwitchClose">
        </div>
      </div>
      <Layout>
        <Header data-html2canvas-ignore></Header>
        <RouterTabs data-html2canvas-ignore></RouterTabs>
        <div class="layout-content">
          <Breadcrumb
            v-show="isShowBreadcrumb"
            data-html2canvas-ignore
          ></Breadcrumb>
          <Content></Content>
        </div>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Content from './Content';
import Header from './Header';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import Breadcrumb from './Breadcrumb.vue';
import RouterTabs from './RouterTabs.vue';

export default {
  name: 'LayoutPage',
  components: {
    Header,
    Breadcrumb,
    Content,
    RouterTabs
  },
  filters: {
    InitportOrgType(v) {
      switch (v) {
        case '0':
          return '运营端';
        case '1':
          return '教育局端';
        case '2':
          return '学校端';
        case '3':
          return '服务端';
      }
    }
  },
  data() {
    return {
      isCollapsed: false,
      portOrg: '',
      downloadUrl: '', // 下载url
      leftSwitchOpen: require('@/assets/img/icon_open@2x.png'),
      leftSwitchClose: require('@/assets/img/icon_close@2x.png')
    };
  },
  computed: {
    ...mapState(['leftNavOpen', 'leftNavActive', 'userInfo']),
    ...mapGetters(['leftNavList', 'leftSwitch']),
    rotateIcon() {
      return ['menu-icon', this.isCollapsed ? 'rotate-icon' : ''];
    },
    menuitemClasses() {
      return ['menu-item', this.isCollapsed ? 'collapsed-menu' : ''];
    },
    isShowBreadcrumb() {
      return this.$route.meta.showBreadcrumb ? this.$route.meta.showBreadcrumb : (this.$route.path != '/index' && this.$route.path.split('/').filter(item => { return item != ''; }).length < 4);
    }
  },
  watch: {
    leftNavOpen(newVal, oldVal) {
      this.$nextTick(() => {
        this.$refs.menu.updateOpened();
        this.$refs.menu.updateActiveName();
      });
    },
    leftNavList(newVal, oldVal) {
      this.$refs.menu.updateOpened();
      this.$refs.menu.updateActiveName();
    }
  },
  created() {
    this.portOrg = localStorage.getItem('portOrg');
  },
  methods: {
    ...mapMutations([
      'SET_LEFTSWITCH'
    ]),
    handleLeftSwitch() {
      this.SET_LEFTSWITCH(!this.leftSwitch);
    },
    onMenuSelect(menu) {
      // 获取内容区缓存对象，然后进行组件卸载
      // try {
      //   let keepAliveComponentInstance = this.$store.state.keepAliveComponentInstance.cache[menu]
      //   if (keepAliveComponentInstance) {
      //     keepAliveComponentInstance.componentInstance.$destroy()
      //   }
      // } catch (err) {

      // }

    }
  }
};
</script>

<style lang="scss" scoped>
.layout {
  // border: 1px solid #d7dde4;
  background: #eff0f8;
  position: relative;
  border-radius: 4px;
  height: 100%;
  min-width: 1280px;
  .left-box {
    max-width: 180px;
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    background-color: #0958d9;
    z-index: 1;
    .logo {
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 16px;
      .box {
        min-width: 40px;
        min-height: 40px;
        background: url('~@/assets/img/logo@2x.png') no-repeat;
        background-size: 100% 100%;
        margin-right: 8px;
      }
      .text {
        max-width: 140px;
        .text-title {
          // margin-bottom: 8px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 22px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          max-height: 44px;
          cursor: pointer;
        }
        .text-role {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }
      }
    }
    .info-box {
      width: 100%;
      min-height: 100px;
      // border-top: 4px solid rgba(255, 255, 255, 0.1);
      position: relative;
      z-index: 999;
      padding-bottom: 20px;
      .align-items {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 100% 100%;
        border: 1px solid #eeeeee;
        margin: 10px 0;
      }
      .name {
        cursor: pointer;
        height: 32px;
        line-height: 32px;
        color: #fff;
        font-size: 14px;
        width: 100%;
        padding: 0 50px;
      }
    }
    .left-nav-cell {
      flex: 1;
      overflow-y: scroll;
      background-color: #0958d9;
      .left-nav {
      }
      // /deep/ ul.ivu-menu.ivu-menu-dark.ivu-menu-vertical.menu-item {
      //   z-index: 0;
      // }
    }
    .left-nav-cell::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .left-nav-switch {
      cursor: pointer;
      position: fixed;
      left: 148px;
      bottom: 0;
      width: 32px;
      height: 32px;
      background: #0055cf;
      border-radius: 2px 0px 0px 0px;
      box-sizing: border-box;
      padding: 7px 0 0 6px;
      img {
        width: 20px;
        height: 18px;
      }
    }
    .leftNavClose {
      left: 40px;
    }
  }
  .layout-logo-left {
    width: 90%;
    height: 30px;
    background: #fff;
    border-radius: 3px;
    margin: 15px auto;
  }
  .menu-icon {
    transition: all 0.3s;
  }
  .rotate-icon {
    transform: rotate(-90deg);
  }
  .menu-item span {
    display: inline-block;
    overflow: hidden;
    width: 100px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width 0.2s ease 0.2s;
  }
  .menu-item i {
    transform: translateX(0px);
    transition: font-size 0.2s ease, transform 0.2s ease;
    vertical-align: middle;
    font-size: 16px;
  }
  .collapsed-menu span {
    width: 0px;
    transition: width 0.2s ease;
  }
  .collapsed-menu i {
    transform: translateX(5px);
    transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
    vertical-align: middle;
    font-size: 22px;
  }
  .layout-content {
    margin: 16px;

    border-radius: 2px;
  }
}
</style>

<style lang="scss">
.layout .ivu-layout-has-sider {
  height: 100%;
}
.layout .left-nav .ivu-menu-submenu-title > i {
  margin-right: -8px;
}
.layout .top-nav .ivu-dropdown-rel {
  display: flex;
}
.ivu-layout-sider {
  background-color: #fff !important;
}
.ivu-menu-item {
  background-color: #f9f8ff !important;
  padding-left: 22px !important;
}
.ivu-menu-item :hover {
  /* color: #fff !important;
  background: #7c68f7 !important; */
}
.ivu-menu-dark {
  background-color: #fff !important;
  color: #666 !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
  background-color: #0958d9 !important;
  color: #fff !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title {
  color: #fff !important;
  background-color: #0958d9 !important;
  padding: 14px 18px;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item {
  background-color: #044bca !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  color: #fff !important;
  background: #003fbb !important;
}

.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  color: #fff;
  background: #003fbb !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
  background: #488ffa;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
  background-color: #488ffa !important;
}
.layout {
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item:hover {
    color: #fff !important;
    background: #003fbb !important;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active,
  .ivu-menu-dark.ivu-menu-vertical
    .ivu-menu-submenu
    .ivu-menu-item-active:hover {
    background-color: #003fbb !important;
    font-weight: bold;
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -7px;
      display: inline-block;
      border: 7px solid transparent;
      border-bottom: 7px solid #f3f5f8;
      z-index: 10010;
    }
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
  .ivu-menu-dark.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu):hover,
  .ivu-menu-dark.ivu-menu-vertical
    .ivu-menu-submenu-title-active:not(.ivu-menu-submenu),
  .ivu-menu-dark.ivu-menu-vertical
    .ivu-menu-submenu-title-active:not(.ivu-menu-submenu):hover {
    background-color: #003fbb !important;
    color: #fff !important;
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -7px;
      display: inline-block;
      border: 7px solid transparent;
      border-right: 7px solid #eef0f3;
      z-index: 10010;
    }
  }
}
.left-box {
}
</style>
